import {gql} from 'apollo-boost'

export const SUBSCRIBE = gql`
mutation subscribe(
  $investorAccountID: String!
  $modelID: String!
  $placeOrderMode: String!
  $placeOrderBuySlip: Int!
  $placeOrderSellSlip: Int!
  $orderExpiryDay: Int!
  $signalTriggerParam: Int
  $rebalanceParam: Int
) {
  subscribe(input:{
    investorAccountID : $investorAccountID
    modelID: $modelID
    placeOrderMode: $placeOrderMode
    placeOrderBuySlip: $placeOrderBuySlip
    placeOrderSellSlip :$placeOrderSellSlip
    orderExpiryDay: $orderExpiryDay
    signalTriggerParam: $signalTriggerParam
    rebalanceParam: $rebalanceParam
  }) {
    __typename
    ... on SubscribeOutput {
      subscriptionID
    }
    ... on Error {
      code
      message
    }
  }
}
`
export const PROFITSHARING_UNSUBSCRIBE = gql`
 query profitSharing($subscriptionID: String!) {
   profitsharingUnsubscribe(
     subscriptionID: $subscriptionID
   ) {
     __typename
     ... on ProfitsharingUnsubscribeOutput {
     profitSharing
   }
    __typename
    ... on Error {
      code 
      message
    }
 }
 }
    
`
export const UNSUBSCRIBE = gql`
mutation unsubscribe(
  $subscriptionID: String!
  $isSellAll : Boolean!
) {
  unsubscribe(input:{
    subscriptionID: $subscriptionID,
    isSellAll : $isSellAll,
  }) {
    __typename
    ... on UnsubscribeOutput {
      subscriptionID
      isDeleted
    }
    ... on Error {
			code
      message
    }
  }
}
`

export const UPDATE_INVESTOR_SUBSCRIPTION = gql`
mutation updateInvestorSubscription(
  $subscriptionID: String!
 $placeOrderMode: String!
 $placeOrderBuySlip: Int!
 $placeOrderSellSlip: Int!
 $orderExpiryDay: Int!
 $signalTriggerParam: Int
 $rebalanceParam: Int
) {
 updateInvestorSubscription(input:{
   subscriptionID: $subscriptionID
   placeOrderMode : $placeOrderMode
   placeOrderBuySlip : $placeOrderBuySlip
   placeOrderSellSlip : $placeOrderSellSlip
   orderExpiryDay : $orderExpiryDay
   signalTriggerParam : $signalTriggerParam
   rebalanceParam : $rebalanceParam
 }) {
   __typename
   ... on UpdateInvestorSubscriptionOutput {
     subscriptionID
   }
   ... on Error {
     code
     message
   }
 }
}
`
